// extracted by mini-css-extract-plugin
export var editButton = "_is-0";